import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NavBar from './NavBar';
import styled from 'styled-components/macro';

const Master = ({
    areas,
    children,
    title,
}) => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        window.addEventListener('scroll', resizeHeaderOnScroll);
        return () => window.removeEventListener('scroll', resizeHeaderOnScroll);
    }, []);

    const resizeHeaderOnScroll =() => {
        const distanceY = window.pageYOffset || document.documentElement.scrollTop;
        setScrollY(distanceY);
    };

    return <>
        <Sticky>
            <NavBar
                areas={ areas }
                title={ title }
                scrollY={ scrollY }
            />
        </Sticky>
        {children}
    </>;
};

Master.propTypes = {
    areas: PropTypes.any,
    children: PropTypes.object,
    title: PropTypes.string,
};

Master.defaultProps = {
    showFooter: true,
    title: 'Areas of Wisdom',
};

export default Master;

const Sticky = styled.div`
    position: fixed;
    top: 0;
    z-index: 30;
    background: transparent;
    pointer-events: none;
    width: 100%;
`;
